import { render, staticRenderFns } from "./ui-textarea.vue?vue&type=template&id=12192eef&"
import script from "./ui-textarea.vue?vue&type=script&lang=js&"
export * from "./ui-textarea.vue?vue&type=script&lang=js&"
import style0 from "./ui-textarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12192eef')) {
      api.createRecord('12192eef', component.options)
    } else {
      api.reload('12192eef', component.options)
    }
    module.hot.accept("./ui-textarea.vue?vue&type=template&id=12192eef&", function () {
      api.rerender('12192eef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-textarea/ui-textarea.vue"
export default component.exports